///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.unsolicited = abcsetup.consumer_rfp.unsolicited || {};
abcsetup.consumer_rfp.unsolicited.create = abcsetup.consumer_rfp.unsolicited.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.unsolicited.create = {
    /**
     *
     */
    init: function () {

        abcsetup.setTitle('Unsolicited Bid');

         // Init the common lib
         abcsetup.consumer_rfp.unsolicited.common.init();
    }
}
